module.exports = __webpack_public_path__ + "assets/img/15_373_big.e7412c22.jpg";